import React, { useCallback, useEffect, useState } from 'react';
import { OpenDetailedFiltersButton } from './styles';
import { Badge } from '@mui/material';
import { FilterList } from '@mui/icons-material';
import { LabelLarge } from '../../styles';
import { Filters, FiltersObject } from '../../utils';
import { useTranslations } from 'next-intl';

type FiltersToggleProps = {
    filters: FiltersObject;
    onClick: () => void;
    isDisabled: boolean;
    shouldShowBadge?: boolean;
    shouldShowLabel?: boolean;
};

const FiltersToggle = ({
    filters,
    isDisabled,
    onClick,
    shouldShowBadge = true,
    shouldShowLabel = true
}: FiltersToggleProps) => {
    const t_filters = useTranslations('filtering');
    const [hasHiddenFilters, setHasHiddenFilters] = useState<boolean>(false);

    const checkHiddenFilters = useCallback(() => {
        const quickFiltersOnly = [Filters.Services, Filters.Example];

        const result = Object.entries(filters).some(
            ([key, value]) => !quickFiltersOnly.includes(key as Filters) && value?.length > 0
        );
        setHasHiddenFilters(result && shouldShowBadge);
    }, [filters, shouldShowBadge]);

    useEffect(() => {
        checkHiddenFilters();
    }, [checkHiddenFilters]);

    return (
        <OpenDetailedFiltersButton
            onClick={onClick}
            disabled={isDisabled}
            data-testid='detailed-filters-opener'
            hasExtraRightPadding={shouldShowLabel}
        >
            <Badge variant='dot' color='primary' invisible={!hasHiddenFilters}>
                <FilterList />
                {shouldShowLabel && (
                    <LabelLarge ml={1}>{t_filters('open_detailed_filters_label')}</LabelLarge>
                )}
            </Badge>
        </OpenDetailedFiltersButton>
    );
};

export { FiltersToggle };
